(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/tipset/assets/javascripts/models/header.js') >= 0) return;  svs.modules.push('/modules/tipset/assets/javascripts/models/header.js'); (function(Backbone, _, svs) {
  'use strict';

  svs.tipset.models.Header = Backbone.Model.extend({
    log: new svs.core.log.Logger('svs.tipset.models.Header'),
    headerIcon: '',
    defaults: {
      title: '',
      leftButtons: [],
      rightButtons: []
    },

    initialize: function() {
      this.headerIcon = svs.tipset.models.gameDefinitions.get('htmlClass');
      this.set('title', { row1: { brand: this.headerIcon } });
      this.log.debug('initialize', this.attributes);
      svs.core.template.updateConfig({
        title: this.get('title'),
        leftButtons: this.get('leftButtons'),
        rightButtons: this.get('rightButtons')
      });
      var self = this;
      this.listenTo(this, 'change', function() {
        self.log.debug('change', this.attributes);
        svs.core.template.updateConfig({
          title: self.get('title'),
          leftButtons: self.get('leftButtons'),
          rightButtons: self.get('rightButtons')
        });
      });
    },

    resetCenter: function() {
      this.set('title', {
        row1: {
          brand: this.headerIcon,
          alt:
            this.headerIcon.charAt(0).toUpperCase() + this.headerIcon.slice(1)
        }
      });
    },

    reset: function() {
      this.set(this.defaults);
    }
  });
})(Backbone, _, svs);

 })(window);